import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { Close, Upload } from "@mui/icons-material";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Button,
  DialogActions,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
  IconButton,
  Divider,
  Tooltip,
} from "@mui/material";
import { currencyFormatter } from "../../../../../utils/formatUtils";
import ProjectDetailsInvestorAdd from "../ProjectDetailsInvestorAdd";
import InvestmentRemove from "../InvestmentRemove";
import InvestmentsExcelDownload from "./InvestmentsExcelDownload";
import InvestmentsExcelUpload from "./InvestmentsExcelUpload";
import Decimal from "decimal.js";

const styles = {
  container: {
    display: "block",
  },
  content: {
    paddingY: 0,
  },
  actions: {
    paddingRight: "1rem",
  },
  title: {
    my: "1rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  fieldWrapper: {
    px: "1rem",
  },
};

const ProjectDetailsInvetsments = (props) => {
  const params = useParams();
  const investments = useSelector((state) => state.investments.list);
  const project = useSelector((state) => state.projects.current);
  const [openAdd, setOpenAdd] = useState(false);
  const [openUpload, setOpenUpload] = useState(false);

  const handleClose = (e) => {
    e.preventDefault();
    props.onClose();
  };

  const handleOpenAdd = () => setOpenAdd(true);
  const handleCloseAdd = () => setOpenAdd(false);
  const handleOpenUpload = () => setOpenUpload(true);
  const handleCloseUpload = () => setOpenUpload(false);

  return (
    <>
      <Dialog open={props.open} onClose={handleClose}>
        <DialogTitle>
          <Box sx={styles.title}>
            <Typography variant="h5">Lista de Inversioniones</Typography>
            <IconButton onClick={handleClose}>
              <Close />
            </IconButton>
          </Box>
          <Divider />
        </DialogTitle>
        <DialogContent sx={styles.content}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>#</TableCell>
                <TableCell>Inversionista</TableCell>
                <TableCell>Nombre Inversión</TableCell>
                <TableCell>Vehículo</TableCell>
                <TableCell>Capital</TableCell>
                <TableCell>Participación global</TableCell>
                <TableCell>Participación IDE</TableCell>
                <TableCell sx={{ textAlign: "center" }}>Borrar</TableCell>
                {/* <TableCell>Crédito</TableCell> */}
              </TableRow>
            </TableHead>
            <TableBody>
              {investments.map((investment, index) => (
                <TableRow key={investment._id}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>
                    <Link
                      to={`/dashboard/asociados/${investment.associateRef?._id}/inversion/${investment._id}`}
                    >
                      {investment.associateRef?.name}
                    </Link>
                  </TableCell>
                  <TableCell>{investment.investor}</TableCell>
                  <TableCell>{investment?.vehiculo ?? ""}</TableCell>
                  <TableCell>
                    {currencyFormatter.format(investment.capital)}
                  </TableCell>
                  <TableCell sx={{ textAlign: "center" }}>
                    {investment.participation}%
                  </TableCell>
                  <TableCell sx={{ textAlign: "center" }}>
                    {investment?.participationIDE ? (
                      new Decimal(investment.participationIDE)
                        .toString()
                        .split(".")[1]?.length > 2 ? (
                        <Tooltip
                          title={`${new Decimal(
                            investment.participationIDE
                          ).toString()}%`}
                          arrow
                        >
                          <span>
                            {new Decimal(investment.participationIDE).toFixed(
                              2
                            )}
                            %
                            <span
                              style={{ color: "#1976d2", fontWeight: "bold" }}
                            >
                              {" "}
                              +
                            </span>
                          </span>
                        </Tooltip>
                      ) : (
                        `${new Decimal(investment.participationIDE).toFixed(
                          2
                        )}%`
                      )
                    ) : (
                      "-"
                    )}
                  </TableCell>
                  <TableCell sx={{ textAlign: "center" }}>
                    <InvestmentRemove investment={investment} />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </DialogContent>
        <DialogActions sx={styles.actions}>
          <Box
            sx={{
              display: "flex",
              gap: 1,
              width: "100%",
              justifyContent: "space-between",
            }}
          >
            <Box sx={{ display: "flex", gap: 1 }}>
              <InvestmentsExcelDownload
                investments={investments}
                project={project}
              />
              <Button
                variant="outlined"
                startIcon={<Upload />}
                onClick={handleOpenUpload}
              >
                Actualización masiva
              </Button>
            </Box>
            <Button onClick={handleOpenAdd}>Añadir</Button>
          </Box>
        </DialogActions>
      </Dialog>
      <ProjectDetailsInvestorAdd open={openAdd} onClose={handleCloseAdd} />
      <InvestmentsExcelUpload
        open={openUpload}
        onClose={handleCloseUpload}
        projectId={params.id}
        currentInvestments={investments}
      />
    </>
  );
};

export default ProjectDetailsInvetsments;
